import { gql } from '@apollo/client';

export function getPersonAddressLovs() {
  return gql`
    query getPersonAddressLovs {
      PersonAddressType: __type(name: "PersonAddressType") {
        name
        enumValues {
          name
        }
      }
      core {
        getCountries {
          id
          code
          title
        }
        getZones {
          id
          code
          title
        }
      }
    }
  `;
}

export function createPersonAddress() {
  return gql`
    mutation createPersonAddress(
      $input: CreatePersonAddressInput!
      $proposalID: String
    ) {
      salesforce {
        createPersonAddress(input: $input, proposalID: $proposalID)
      }
    }
  `;
}

export function updatePersonAddress() {
  return gql`
    mutation updatePersonAddress($input: ModifyPersonAddressInput!) {
      salesforce {
        modifyPersonAddress(input: $input)
      }
    }
  `;
}

export function getPersonAddressDetailsInfo() {
  return gql`
    query getPersonAddressDetailsInfo($id: String!) {
      SalesforceManagement {
        entities {
          personAddress(id: $id) {
            views {
              SalesforceManagement_all {
                properties {
                  PersonID {
                    id
                  }
                  AddressType
                  Address {
                    City
                    Street
                    Street
                    Building
                    AddressDetails
                    AddressDetailsArabic
                    Country {
                      Title
                      Id
                    }
                    Zone {
                      Title
                      Id
                    }
                  }
                  IsPrimary
                }
              }
            }
          }
        }
      }
    }
  `;
}

export function getZonesByCountry() {
  return gql`
    query getZonesByCountry($countryID: String!) {
      Insurance {
        lookups {
          zones(Insurance_Countries: $countryID) {
            Id
            Title
          }
        }
      }
    }
  `;
}
